import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const MicroTuningFunction = ({effect}) => { 
    let [script, setScript] = useState(effect.scriptParameter.get());
    let [hasError, setHasError] = useState(false);

    const onClick = useCallback(() => {
        effect.scriptParameter.set(script);
    }, [script]);

    const onChange = useCallback((e) => {
        let text = e.target.value;
        if(effect.executeScript(text)) {
            effect.scriptParameter.set(text, true, false);
            setHasError(false);
        } else {
            setHasError(true);
        }
        setScript(text);
    }, [setScript, setHasError]);

    return (
        <div
          className={hasError ? "micro-tuning-function error" : "micro-tuning-function"}>
          <input
            className="micro-script-input"
            value={script} type="text" onChange={onChange}/>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MicroTuningFunction);
